// Check if window is defined (so if in the browser or in node.js).
// this is to avoid throwing window not defined errors while building the website
export const isBrowser = typeof window !== "undefined"